export const TYRES_OPC = 'opc'; //operatore centro
export const TYRES_OPA = 'opa'; //operatore ald
export const TYRES_OPF = 'opf'; //operatore flotta
export const TYRES_OPS = 'ops'; //customer service